/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
import { Avatar, Button, Form, Input, message, Upload, Select } from "antd";
import type { RcFile } from "antd/es/upload/interface";
import React, { useEffect, useState } from "react";
import Colors from "../../config/Colors";
import {
  clickHereDraggerStyles,
  headerDraggerStyles,
  ImageBox,
  subtitleDraggerStyles,
} from "./styles";
import { CustomIcons } from "../../assets";
import DaggerCard from "../Cards/DaggerCard/DaggerCard";
import { Emergencies } from "../../services";

const MAX_LENGTH = 200;
const { Dragger } = Upload;

type NewEmergencyFormProp = {
  emergencyValues?: any;
  onFormFinish: (emergency: IEmergency) => void;
  onModelClose: () => void;
  isLoading: boolean;
  isSuccess: boolean;
  onDelete?: () => void;
  showDelete?: boolean;
  isDeleting?: boolean;
};

const NewEmergencyForm = ({
  emergencyValues,
  onFormFinish,
  onModelClose,
  isLoading,
  isSuccess,
  onDelete,
  showDelete = false,
  isDeleting = false,
}: NewEmergencyFormProp) => {
  const [form] = Form.useForm();
  const [charactersLeft, setCharactersLeft] = useState(MAX_LENGTH);
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState<boolean>(false);

  const onFinish = async (formValues: any) => {
    const values: IEmergency = formValues as IEmergency;

    await onFormFinish(values);
  };

  const handleClose = () => {
    form.resetFields();
    setCharactersLeft(MAX_LENGTH);
    onModelClose();
  };

  // Manual upload function using service layer
  const handleImageUpload = async (file: RcFile): Promise<string | false> => {
    // Validate file type
    const isJpegOrPngOrGif = ["image/jpeg", "image/png", "image/gif"].includes(
      file.type
    );
    if (!isJpegOrPngOrGif) {
      message.error("You can only upload JPG/PNG/GIF file!");
      return false;
    }

    // Validate file size (2MB)
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
      return false;
    }

    try {
      setUploading(true);
      const path = await Emergencies.uploadDocument(file);
      message.success("Image uploaded successfully!");
      return path;
    } catch (error: any) {
      message.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to upload image"
      );
      return false;
    } finally {
      setUploading(false);
    }
  };

  // Handle before upload - prevent automatic upload
  const beforeUpload = (file: RcFile) => {
    handleImageUpload(file).then((path) => {
      if (path) {
        setImageUrl(path);
        form.setFieldsValue({ iconPath: path });
      }
    });
    return false; // Prevent automatic upload
  };

  useEffect(() => {
    if (emergencyValues) {
      form.setFieldsValue(emergencyValues);
      if (emergencyValues.iconPath) {
        setImageUrl(emergencyValues.iconPath);
      }
      if (emergencyValues.emergencyDiscription) {
        setCharactersLeft(
          MAX_LENGTH - emergencyValues.emergencyDiscription.length
        );
      }
    } else {
      form.resetFields();
    }
  }, [emergencyValues, form]);

  useEffect(() => {
    if (isSuccess) {
      setCharactersLeft(MAX_LENGTH);
      form.resetFields();
    }
  }, [isSuccess]);

  return (
    <Form
      form={form}
      name="newEmergency"
      onFinish={onFinish}
      // onFinishFailed={onFinishFailed}
      layout="vertical"
      style={{ width: "100%" }}
      className="grid"
      initialValues={emergencyValues}
    >
      <div className="col-12">
        <Form.Item
          name="emergencyType"
          label="Name of emergency"
          rules={[{ required: true, message: "Please enter emergency name!" }]}
          className="mb-1"
        >
          <Input size="large" placeholder="Armed response" />
        </Form.Item>
      </div>
      <div className="col-12">
        <Form.Item
          name="emergencyDiscription"
          label="Description"
          rules={[
            { required: true, message: "Please enter emergency description!" },
            {
              max: MAX_LENGTH,
              message: `Description cannot be longer than ${MAX_LENGTH} characters`,
            },
          ]}
          className="mb-1"
        >
          <>
            <Input.TextArea
              value={form.getFieldValue("emergencyDiscription")}
              placeholder="In a life threatening situation we can send out an armed responded"
              maxLength={MAX_LENGTH}
              onChange={(e) => {
                form.setFieldsValue({ emergencyDiscription: e.target.value });
                setCharactersLeft(MAX_LENGTH - e.target.value.length);
              }}
              rows={3}
            />
            {charactersLeft <= 100 && (
              <div
                className="py-1"
                style={{
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  color: Colors.subtleTextColor,
                }}
              >
                {charactersLeft} characters left
              </div>
            )}
          </>
        </Form.Item>
      </div>
      <div className="col-12">
        <Form.Item
          name={"whiteLabelId"}
          label="Select a white-label app"
          className="mb-1"
          required
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                const whiteLabelId = getFieldValue("whiteLabelId");

                if (whiteLabelId && !value) {
                  return Promise.reject(
                    new Error("Please select a white-label app!")
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Select
            onChange={(value) => {
              const tenantMapping = {
                0: "SaferCity",
                1: "Curro",
              };
              form.setFieldsValue({
                TenantClientId:
                  tenantMapping[value as keyof typeof tenantMapping],
              });
            }}
            placeholder="White-label app"
            size="large"
            options={[
              { value: 0, label: "SaferCity" },
              { value: 1, label: "Curro" },
            ]}
          />
        </Form.Item>
      </div>
      <Form.Item
        name="iconPath"
        label="Icon"
        rules={[{ required: true, message: "Please enter emergency icon!" }]}
        className="mb-5 col-12"
      >
        <div className="flex w-full gap-6 flx-row justify-content-start">
          {imageUrl.length > 0 ? (
            <Avatar
              shape="square"
              size={64}
              alt="emergency icon"
              src={imageUrl}
            />
          ) : (
            <Avatar shape="square" size={64} alt="emergency icon" />
          )}
          <Dragger
            name="file"
            multiple={false}
            beforeUpload={beforeUpload}
            className="w-full"
            style={{ background: "transparent" }}
            maxCount={1}
            showUploadList={false}
            accept=".jpg,.jpeg,.png,.gif"
            disabled={uploading}
          >
            <DaggerCard />
          </Dragger>
        </div>
      </Form.Item>
      <Form.Item className="w-12 pt-2 mb-1">
        <div className="flex w-full gap-2 col-12 justify-content-between align-content-center">
          {/* {showDelete && onDelete && (
            <Button
              type="text"
              danger
              icon={
                <CustomIcons.TrashBinIcon
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  svgColor="#ff4d4f"
                />
              }
              onClick={onDelete}
              disabled={isLoading || isDeleting}
              size="large"
              className="flex align-items-center"
            >
              Delete Emergency
            </Button>
          )} */}
          <div
            className="flex gap-2 justify-content-end"
            style={{ marginLeft: "auto" }}
          >
            <Button
              type="primary"
              ghost
              onClick={handleClose}
              size="large"
              className="w-9"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              size="large"
              className="w-9 bg-[#1757a2] shadow-none"
            >
              Save
            </Button>
          </div>
        </div>
      </Form.Item>
    </Form>
  );
};

export default NewEmergencyForm;
